import { AIRPORT_CITY, MARKET, RING_ROAD, TOWN, UNIVERSITY } from './streetscapes';
import type { Route } from './types';

/** Madina ⇄ Accra (Makola), stops as given by the owner. Distances are game-scale, not real. */
export const MADINA_ACCRA: Route = {
  id: 'madina-accra',
  name: 'Madina ⇄ Accra',
  from: 'Madina',
  to: 'Accra (Makola)',
  length: 6000,
  legs: [
    { id: 'madina', name: 'Madina', subtitle: 'Madina Market to UPSA', start: 0, end: 900, traffic: 1.2, streetscape: MARKET },
    { id: 'legon', name: 'Legon', subtitle: 'University of Ghana', start: 900, end: 1800, traffic: 0.9, streetscape: UNIVERSITY },
    { id: 'shiashie', name: 'Shiashie', subtitle: 'Okponglo to Spanner', start: 1800, end: 2700, traffic: 1.0, streetscape: RING_ROAD },
    { id: 'airport', name: 'Airport', subtitle: 'Airport First & Second', start: 2700, end: 3700, traffic: 0.9, streetscape: AIRPORT_CITY },
    { id: 'liberation', name: 'Liberation Road', subtitle: '37 to Shangri-La', start: 3700, end: 4600, traffic: 1.0, streetscape: AIRPORT_CITY },
    { id: 'ridge-makola', name: 'Ridge to Makola', subtitle: 'Ridge Roundabout, Novotel, Makola', start: 4600, end: 6000, traffic: 1.2, streetscape: TOWN },
  ],
  stops: [
    { id: 'madina', name: 'Madina', at: 160, crowd: [6, 10] },
    { id: 'upsa', name: 'UPSA', at: 620, crowd: [3, 7] },
    { id: 'legon', name: 'Legon', at: 1100, crowd: [4, 8] },
    { id: 'okponglo', name: 'Okponglo', at: 1560, crowd: [2, 5] },
    { id: 'shiashie', name: 'Shiashie', at: 2020, crowd: [2, 5] },
    { id: 'spanner', name: 'Spanner', at: 2480, crowd: [2, 5] },
    { id: 'airport-1', name: 'Airport First', at: 2980, crowd: [3, 6] },
    { id: 'airport-2', name: 'Airport Second', at: 3440, crowd: [2, 5] },
    { id: '37', name: '37', at: 3900, crowd: [4, 8] },
    { id: 'shangri-la', name: 'Shangri-La', at: 4360, crowd: [2, 4] },
    { id: 'ridge', name: 'Ridge Roundabout', at: 4860, crowd: [3, 6] },
    { id: 'novotel', name: 'Novotel', at: 5320, crowd: [2, 5] },
    { id: 'makola', name: 'Accra (Makola)', at: 5760, crowd: [6, 10] },
  ],
  junctions: [
    { id: 'madina-zongo', name: 'Madina Zongo junction', at: 380 },
    { id: 'upsa', name: 'UPSA junction', at: 860 },
    { id: 'okponglo', name: 'Okponglo junction', at: 1820 },
    { id: 'tetteh-quarshie', name: 'Tetteh Quarshie', at: 2740 },
    { id: 'airport', name: 'Airport junction', at: 3660 },
    { id: 'ridge', name: 'Ridge junction', at: 4620 },
    { id: 'makola', name: 'Makola junction', at: 5540 },
  ],
  stations: [
    { id: 'nyame-fuel', name: 'Nyame Fuel', at: 980 },
    { id: 'goil-ridge', name: 'Gold Coast Oil', at: 3100 },
    { id: 'star-oil', name: 'Star Oil', at: 5000 },
  ],
};
